<template>
  <div>
    <Header62 v-if="gameId === 62"/>
    <Header69 v-else-if="gameId === 69"/>
    <HeaderDefault v-else/>
  </div>
</template>

<script>
  import HeaderDefault from './HeaderDefault.vue'
  import Header62 from './Header62.vue'
  import Header69 from './Header69.vue'
  export default {
    name: 'AnsiAccreditation',
    components: {Header69, Header62, HeaderDefault},
    data: () => ({
      gameId: process.env.GAME_ID
    })
  }
</script>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue